export default [{
    path: '/currency',
    name: 'currency',
    meta: {
      layout: 'main'
    },
    component: () => import('@/views/currency/index')
  }]
